import { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { Spin } from 'antd';
import { router } from './routes';
import { ConfigProvider, notification } from '@components';
import { ToastContainer } from 'react-toastify';
import { useInitializeAuth } from './store/useStore';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  const renderRoutes = useRoutes(router);

  // Initialize authentication state on app startup
  useInitializeAuth();

  notification.config({
    placement: 'bottomLeft',
    duration: 30000,
    rtl: true,
    maxCount: 3,
    top: 200,
  });

  return (
    <ConfigProvider>
      <Suspense fallback={<Spin />}>{renderRoutes}</Suspense>
      <ToastContainer
        position="top-left"
        autoClose={5000}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        closeButton={false}
      />
      <footer style={{ textAlign: 'center', marginTop: 20, display: 'none' }}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://fontiran.com/license/1LOHNPXS"
          style={{
            display: 'inline-block',
            textDecoration: 'none',
            color: 'inherit',
          }}>
          <div style={{ width: 123, fontSize: 10 }}>
            <img
              src="https://fontiran.com/storage/uploads/images/2023/1/badge1-minDN14Uj.png"
              width="50"
              height="50"
              alt="فونت کوک"
            />
            <br />
            <span style={{ textAlign: 'justify', display: 'block' }}>
              این وبسایت به صورت قانونی از فونت کوک استفاده می‌کند.
            </span>
          </div>
        </a>
      </footer>
    </ConfigProvider>
  );
}

export default App;
